<template>
  <q-page class="q-pa-md bg-grey-2">
    <div class="row q-col-gutter-md">
      <div class="col-12">
        <q-card class="bg-primary text-white">
          <q-card-section>
            <div class="text-h4">Управление модулями</div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div class="row q-col-gutter-md">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <q-table :rows="modules" :columns="columns" row-key="name" :loading="loading">


              <template v-slot:body-cell-actions="props">
                <q-td :props="props">
                  <q-btn flat round color="primary" icon="edit" @click="openModuleDialog(props.row)" />
                  <!-- <q-btn flat round color="negative" disable icon="delete" @click="deleteModule(props.row)" /> -->
                </q-td>
              </template>
            </q-table>
          </q-card-section>
          <q-card-section>
            <!-- <q-btn color="primary" disable label="Добавить" @click="openModuleDialog()" /> -->
          </q-card-section>
        </q-card>
      </div>
    </div>

    <q-dialog v-model="moduleDialog" persistent>
      <q-card style="min-width: 350px">
        <q-card-section>
          <div class="text-h6">{{ editingModule ? 'Редактировать модуль' : 'Добавить модуль' }}</div>
        </q-card-section>

        <q-card-section>
          <q-form @submit="saveModule" class="q-gutter-md">
            <q-input v-model="currentModule.name" label="Название" :rules="[val => !!val || 'Обязательное поле']" />
            <q-input v-model="currentModule.description" label="Описание" type="textarea" />
            <q-input v-model.number="currentModule.price" label="Стоимость в сутки" type="number"
              :rules="[val => val >= 0 || 'Должно быть больше 0']" />
            <q-toggle v-model="currentModule.is_active" label="Активен" />
            <q-input v-model.number="currentModule.workplaces" label="Рабочих мест базово" type="number"
              :rules="[val => val > 0 || 'Должно быть больше 0']" />
            <q-toggle v-model="currentModule.is_required" disable label="Обязательный модуль" />
            <q-input v-model.number="currentModule.price_per_workplace" label="Цена за рабочее место" type="number"
              :rules="[val => val >= 0 || 'Должно быть больше 0']" />

            <div class="row justify-end q-mt-md">
              <q-btn label="Отмена" color="primary" flat v-close-popup />
              <q-btn label="Сохранить" type="submit" color="primary" />
            </div>
          </q-form>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { apiUrl } from "../config";
import axios from "axios";
import { ref, reactive } from "vue";

const columns = [
  { name: 'name', required: true, label: 'Название', align: 'left', field: 'name', sortable: true },
  { name: 'description', align: 'left', label: 'Описание', field: 'description' },
  { name: 'price', align: 'right', label: 'Стоимость', field: 'price', sortable: true },
  { name: 'is_active', align: 'center', label: 'Активный', field: 'is_active', sortable: true },
  { name: 'is_required', align: 'center', label: 'Обязательный', field: 'is_required', sortable: true },
  { name: 'workplaces', align: 'right', label: 'Рабочих мест', field: 'workplaces', sortable: true },
  { name: 'price_per_workplace', align: 'right', label: 'Цена за рабочее место', field: 'price_per_workplace', sortable: true },
  { name: 'actions', align: 'center', label: 'Действия' }
]

export default {
  name: "modules",
  data() {
    this.fetchModules();
    return {
      columns: ref(columns),
      modules: ref([]),
      loading: ref(false),
      moduleDialog: ref(false),
      editingModule: ref(null),
      currentModule: reactive({
        name: '',
        description: '',
        price: 0,
        is_active: true,
        workplaces: 1,
        is_required: false,
        price_per_workplace: 0
      })
    }
  },
  methods: {
    fetchModules() {
      this.loading = true
      axios
        .post(apiUrl + '/admin/modules/', {}, { auth: this.$store.state.credentials })
        .then((response) => {
          console.log(response)
          if (response.error !== undefined) {
            this.$q.notify({
              color: 'negative',
              message: 'Неизвестная ошибка',
              icon: 'error'
            })
          } else {
            this.modules = response.data.items;
            this.loading = false;
          }
        })
        .catch((error) => {
          console.log(error)
          this.$q.notify({
            color: 'negative',
            message: 'Неизвестная ошибка',
            icon: 'error'
          })
       })
    },
    openModuleDialog(module = null) {
      if (module) {
        this.editingModule = module
        Object.assign(this.currentModule, module)
      } else {
        this.editingModule = null
        Object.assign(this.currentModule, {
          name: '',
          description: '',
          price: 0,
          is_active: true,
          workplaces: 1,
          is_required: false,
          price_per_workplace: 0
        })
      }
      this.moduleDialog = true
    },
    deleteModule(module) {
      console.log(module)
    },
    saveModule() {
      axios
        .post(apiUrl + '/admin/modules/save/', this.currentModule, { auth: this.$store.state.credentials })
        .then((response) => {
          console.log(response)
          this.moduleDialog = false;
          this.fetchModules();
          this.$q.notify({
            color: 'positive',
            message: 'Данные успешно сохранены',
            icon: 'check'
          })
        })
        .catch((error) => {
          console.log(error)
          this.$q.notify({
            color: 'negative',
            message: 'Неизвестная ошибка',
            icon: 'error'
          })
        })
    }
  }
}
</script>

<style scoped>
.q-table__container {
  box-shadow: none;
}
</style>
